meedy.controller('meedy.alabListController', ['$scope', '$state', '$sce', '$mdToast', '$mdDialog', '$translate',
    'meedy.objectHelper', 'applicationModel', 'meedy.termModel', 'meedy.integrationsModel',
    function ($scope, $state, $sce, $mdToast, $mdDialog, $translate, objectHelper, applicationModel, termModel,
              integrationsModel) {

        var listeners = {};

        function setData() {
            var startOFWeek = moment(new Date()).startOf('week').clone().toDate();
            var endOFWeek = moment(new Date()).endOf('week').clone().toDate();
            $scope.filters = [
                {type : 'date', value : startOFWeek, fieldName : 'startDate', label : 'T.MEEDY.MODULE.INVOICE.DATE_FROM'},
                {type : 'date', value : endOFWeek, fieldName : 'endDate', label : 'T.MEEDY.MODULE.INVOICE.DATE_TO'}
            ];
            $scope.alabTerms = [];
            $scope.criteria = new AlabTermDataGridMeedyCriteria();
            $scope.criteria.externalSystem = "ALAB";
            $scope.criteria.type = "EXAMINATION";
            $scope.criteria.startDate = startOFWeek;
            $scope.criteria.endDate = endOFWeek;
            $scope.numberOfPages = 1;

            $scope.columns = [
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.USER.FULL_NAME'),
                    field: "patient.firstName + ' ' + patient.lastName"
                },
                {
                    displayName: $translate.instant('T.MODULE.PERSONAL_DATA.IDENTIFIER'),
                    field: "patient.identifier"
                },
                {
                    displayName: $translate.instant('T.MODULE.VISIT.PHONE'),
                    field: "patient.mainPhone"
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.ALAB.CREATION_DATE'),
                    field: "creationDate | date:'dd.MM.yyyy HH:mm'"
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.USER.STATUS'),
                    field: "status | prefix:'T.ENUM.ALAB_TERM.' | translate"
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.ALAB.FILES'),
                cellTemplate: 'meedy/application/view/app/alab/grid-templates/alab-list-files-actions.html'
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.USER.ACTION'),
                    cellTemplate: 'meedy/application/view/app/alab/grid-templates/alab-list-row-actions.html'
                }
            ];

            $scope.showDoneTerms = false;

        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on('$destroy', function () {
                applicationModel.viewReady = false;
            });

            listeners.onAlabTermsLoad = function (data) {
                $scope.alabTerms = data.data;
                $scope.numberOfPages = data.numberOfPages;
            }
        }

        function setActions() {

            $scope.createALABDelegation = function() {
                $mdDialog.show({
                    templateUrl: 'meedy/application/view/app/alab/popup/popup-create-alab-referral.html',
                    controller: 'meedy.popupCreateAlabReferralController'
                }).then(function() {
                    termModel.getTerms($scope.criteria).then(listeners.onAlabTermsLoad);
                }, function(error){

                })

            };

            $scope.criteriaChanged = function(criteria) {
                termModel.getTerms(criteria.criteria).then(listeners.onAlabTermsLoad);
            };

            $scope.getFileLink = function(dataMap) {
                integrationsModel.getAlabExaminationResultFileLink(dataMap.examination, dataMap.file).then(function(data) {
                    integrationsModel.downloadExaminationFileAndOpenNewTab(data);
                })
            };

            $scope.executeTermVerification = function(term) {

                var confirm = $mdDialog.confirm({
                    title: $translate.instant('T.MEEDY.MODULE.ALAB.EXECUTE_CONFIRMATION_TEXT'),
                    ok: $translate.instant('T.MEEDY.UI.APPLICATION.YES'),
                    cancel: $translate.instant('T.MEEDY.UI.APPLICATION.NO')
                });
                $mdDialog.show(confirm).then(function() {
                    termModel.executeAllForTerm(term).then(function() {
                        termModel.getTerms($scope.criteria).then(listeners.onAlabTermsLoad);
                    });
                }, function() {
                    return false;
                });
            };

            $scope.showDoneTermsDataPage = function() {
                if($scope.showDoneTerms) {
                    $scope.criteria.appointmentStatuses = ["DONE"];
                } else {
                    delete $scope.criteria.appointmentStatuses;
                }

                $scope.criteria.pageNumber = 0;
                termModel.getTerms($scope.criteria).then(listeners.onAlabTermsLoad);
            };

            $scope.reverseStatusForTerm = function(term) {
                termModel.reverseStatusForTerm(term).then(function() {
                    termModel.getTerms($scope.criteria).then(listeners.onAlabTermsLoad);
                });
            }
        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.MEEDY.ALAB.LIST);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.UI.SIDEBAR.DELEGATE_TO_ALAB');
        }

        function initialize() {
            applicationModel.fillViewportMode = true;
            applicationModel.viewReady = true;
            termModel.getTerms($scope.criteria).then(listeners.onAlabTermsLoad);
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
